// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__MW8o0","modalBody":"ConfirmationPop_modalBody__FlK2u"};